import { Clients, Dashboard, Employees, Invoices, Messages, Purchaseinvoices, Salesinvoices, Shareholders, Spends, Transactions, Appreciation, Task, Holiday, Designation, Ticket, Department, TimeSheet, Notice, Settings, Project, Documents, Salary, Leaves, Attendance, Report, TaskReport, AttendanceReport, HR, Work, ProjectFiles, ProjectNotes, Award, Specialday, Reminders,WaterJug } from "../Lib/constants"


const ModulesList = {
    Dashboard: Dashboard,
    Invoices: Invoices,
    Salesinvoices: Salesinvoices,
    Purchaseinvoices: Purchaseinvoices,
    Transactions: Transactions,
    Shareholders: Shareholders,
    Spends: Spends,
    Clients: Clients,
    Messages: Messages,
    Employees: Employees,
    Task: Task,
    Holiday: Holiday,
    Designation: Designation,
    Ticket: Ticket,
    Appreciation: Appreciation,
    Department: Department,
    TimeSheet: TimeSheet,
    Notice: Notice,
    Settings: Settings,
    Project: Project,
    Documents: Documents,
    Salary: Salary,
    Leaves: Leaves,
    Attendance: Attendance,
    Report: Report,
    TaskReport: TaskReport,
    AttendanceReport: AttendanceReport,
    HR: HR,
    Work: Work,
    ProjectFiles: ProjectFiles,
    ProjectNotes: ProjectNotes,
    Award: Award,
    Specialday: Specialday,
    WaterJug: WaterJug,
    Reminders: Reminders,
}

export default ModulesList